import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { AiOutlineFundProjectionScreen } from "react-icons/ai";
import { RxDragHandleDots2 } from "react-icons/rx";
import { GoTasklist } from "react-icons/go";
import { MdSearch, MdAdd, MdSettings, MdMoreHoriz, MdOutlineAddTask } from 'react-icons/md'; 
import Photosicon from '../../assets/photos_icon.png';
 
import { TbEyeEdit } from "react-icons/tb"; 
import { CgLockUnlock, CgLock } from "react-icons/cg";
import Itemeditws from './item-edit-ws'; 
import { IoMdCopy } from 'react-icons/io';
export default function Itemwssortable({ datarow, navigate }) {

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: datarow.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
  const dateRef = useRef(null);
  const duedateRef = useRef(null);
  const [showedititem, setShowedititem] = useState(false);
  //Not Started
  useEffect(() => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const dd = String(today.getDate()).padStart(2, '0');
    const formattedToday = `${yyyy}-${mm}-${dd}`;
    if (dateRef.current) {
      dateRef.current.value = formattedToday;
    }
    if (duedateRef.current) {
      duedateRef.current.value = formattedToday;
    }

  }, []);

  return (
    <div
      key={datarow.id}
      ref={setNodeRef}
      className='table-items' style={{ ...style, borderTop: 'solid 5px ' + datarow.color }}
      {...attributes}
    >
      <table  >
        <tr>
          <td className='item-title'>
            <div style={{
           width: '30px',
            height: '25px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0 0px',
          }}>
            <RxDragHandleDots2 title='Drag Drop' className='move-img' {...listeners} />
            {<div>{datarow.indexstage}</div>}
            </div>
          </td>
          {/* <td><input className='task-Checkbox' type='Checkbox' /></td> */}
          <td>

            <table width='100%'>
              <tr>
                <td><div className='task-name-text'>{datarow.itemname || ""}</div></td>
                <td width='20px'>
                  <TbEyeEdit onClick={() => setShowedititem(true)} title='Edit Item' className='taskicon' />
                  {showedititem && (
                    <Itemeditws data={datarow} onClose={() => setShowedititem(false)} />
                  )}
                </td>
              </tr>
            </table>
          </td>

        </tr>
        <tr>
          <td className='item-title'>Work</td>
          <td>
            <table ><tr>
              <td>
                {datarow.status_complete > 0 ? (
                  <div className="task-status-bar">
                    <div className="task-status-fill" style={{ width: datarow.status_complete + "%" }}>{datarow.status_complete || 0}%</div>
                  </div>
                ) : (
                  <div className="task-status-started-bar">
                    Not Started
                  </div>
                )}

              </td>
              <td width='20px'>
                <MdOutlineAddTask
                  onClick={() => {
                    navigate('/' + datarow.itemuid);

                  }}
                  title="Status"
                  className="taskicon"
                />

              </td>
            </tr></table>
          </td>
        </tr>
        <tr>
          <td className='item-title'>Status</td>
          <td>
              <table ><tr>
              <td>
            <div className="status-div">
              {datarow.itemstatus === "Not accepted" ? (
                <div className="not-started">Not accepted</div>
              ) : (
                <>
                  <div className={`started ${datarow.itemstatus === "Stop" ? "stop" : ""}`}>
                              Stop
                            </div>
                  <div className={`started ${datarow.itemstatus === "Working" ? "done_yellow" : ""}`}>
                    Working
                  </div>
                  <div className={`started ${datarow.itemstatus === "Stuck" ? "done_red" : ""}`}>
                    Stuck
                  </div>
                  <div className={`started ${datarow.itemstatus === "Done" ? "done_green" : ""}`}>
                    Done
                  </div>
                </>
              )}
            </div>
          </td>

     <td width='22px'>
     {datarow.locked === false ? (
                  <CgLockUnlock title='Update item' style={{ color: '#f31d1d' }} className='taskicon' />
                ) : (
                  <CgLock title='Item Locked' style={{ color: '#4caf50' }} className='taskicon' />
                )}
                </td>
                </tr>
                </table>
</td>
        </tr>
        <tr>
          <td className='item-title'>Owner</td>
          <td>
            <table width='100%'><tr>
              <td><img className='owner-img' src={Photosicon}></img></td>
              <td> </td>
              <td> </td>
              <td width='20px'>
                <MdAdd title='Add Owner' className='taskicon' />
              </td>
            </tr></table>
          </td>
        </tr>
        <tr>
          <td className='item-title'>Update</td>
          <td>
            <table width='100%'><tr>
              <td></td>
              <td> {datarow?.update_date_time?.toDate?.()?.toLocaleString?.() || 'No subject'}</td>
              <td width='20px'>
                     <IoMdCopy title='Copy'  className='taskicon' />
              </td>

            </tr>
            </table>
          </td>
        </tr>
        <tr >
          <td className='item-title'>Create</td>
          <td >
            <table width='100%'><tr>
              <td title='Create Date'>

                <span>{datarow?.date_time?.toDate?.()?.toISOString?.().split("T")[0]}</span>
              </td>
              <td><div>&nbsp;Due</div></td>
              <td title='Due Date'>
                <span>{datarow?.due_date_time?.toDate?.()?.toISOString?.().split("T")[0]}</span>
              </td>
            </tr></table>
          </td>
        </tr>
        <tr>
          <td className='item-title'>New</td>
          <td>
            <table width='100%'><tr>
              <td>Add column</td>
              <td width='20px'>
                <MdAdd title='Add Owner' className='taskicon' />
              </td>
            </tr></table>
          </td>
        </tr>
      </table>
    </div>



  );
}
